import React from 'react';
import './index.less';
import { Checkbox, CheckboxProps } from 'antd';

const prefix = 'common-checkbox';
const CommonCheckbox: React.FC<CheckboxProps> = (props) => {

  return (
    <Checkbox {...props} className={`${prefix}`}></Checkbox>
  );
};

export default CommonCheckbox;
